module.exports = __webpack_public_path__ + "img/8.b48a47a2.png";